import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CitationIcon } from './citation-icon';
import { ChatbotMessage } from './types';

interface ChatbotMessageContextProps {
  message: ChatbotMessage;
}

export function ChatbotMessageContext({ message }: ChatbotMessageContextProps) {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={true}
      appear={true}
      timeout={300}
      classNames={{
        appear: 'opacity-0',
        appearActive: 'opacity-100 transition-opacity',
        enter: 'opacity-0',
        enterActive: 'opacity-100 transition-opacity',
        exitActive: 'opacity-0 transition-opacity',
      }}
    >
      <div
        ref={nodeRef}
        className="flex flex-row items-center absolute bottom-[-30px] left-[0px] max-w-[100%] whitespace-nowrap"
      >
        <CitationIcon docType="page" />{' '}
        <span className="ml-1 text-ellipsis overflow-hidden">{message.messageContext?.title}</span>
      </div>
    </CSSTransition>
  );
}
